import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { FaCheckCircle, FaInfoCircle } from "react-icons/fa";
import { getAlertStyles } from "../../../utils/helper";
const Alert = ({ message, type, content = "" }) => {
  const [isVisible, setIsVisible] = useState(true);
  const closeAlert = () => {
    setIsVisible(false);
  };
  const styles = getAlertStyles(type);
  const renderIcon = () => {
    switch (type) {
      case "success":
        return <FaCheckCircle className={styles.text} />;
      case "info":
        return <FaInfoCircle className={styles.text} />;
      default:
        return null;
    }
  };
  if (!isVisible || !message) return null;
  return (
    <div
      className={`flex m-2 items-center justify-between p-3 rounded-[10px] ${styles.background} border ${styles.border}`}
    >
      <div className="flex items-center space-x-3">
        {renderIcon()}
        <div className="flex-1 ml-3">
          <p className={`font-semibold text-[12px] ${styles.text}`}>
            {message}
          </p>
          <p className="text-[12px]">{content}</p>
        </div>
      </div>
      <button
        onClick={closeAlert}
        className="text-xl text-gray-500 hover:text-gray-700"
      >
        <FaTimes />
      </button>
    </div>
  );
};

export default Alert;
